import { CircularProgress, Grid } from "@mui/material";
import { Box } from "@mui/system";
import { Formik } from "formik";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useStyles } from "../../assets/styles/BloodSugarStyles";
import { StyledButton, StyledCrossIcon, StyledFormik } from "../../assets/styles/CommonStyles";
import { capitalizeFirstLetter } from "../../constant/staticHelper";
import { bloodSugarLevel } from "../../constant/staticLists";
import strings from "../../constant/strings";
import * as mainService from "../../services/mainService.js";
import { bloodSugarSchema } from "../../utils/forms/schema.bloodSugarSchema";
import BloodSugarLevelDropdown from "../control/BloodSugarLevelDropdown";
import FieldWrapper from "../InputField/TextFieldWrapper";
import SelectionDropdown from "../control/SelectionDropdown";


const BloodSugar = ({ setOpenModal, getUpdatedValue }) => {
  let initialValues = {
    sugarLevel: "",
    readingMethod: "",
    notes: ""
  }
  const classes = useStyles();
  const bloodSugarLevels = Object.keys(bloodSugarLevel).map(key => ({
    label: capitalizeFirstLetter(key.replace(/_/g, ' ').toLowerCase()),
    level: bloodSugarLevel[key]
  }));
  const [buttonLoading, setButtonLoading] = useState(false);

  const { userData } = useSelector((state) => ({
    userData: state.auth.userData
  }));

  const handleSubmit = async (values, { resetForm }) => {
    const data = {
      blood_sugar: values.sugarLevel,
      reading_method: values.readingMethod,
      notes: values.note,
      token: userData.token
    }
    const res = await mainService.addBloodSugarApi(data);
    if (res.response_type === "fail") {
      setButtonLoading(false);
      toast.error(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: {width: 'auto', borderRadius: 8 }});
    } else {
      resetForm();
      setButtonLoading(false);
      getUpdatedValue(true);
      setOpenModal(false);
      toast.success(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: {width: 'auto', borderRadius: 8 }});
    }
  }

  return (
    <div>
      <Grid className={classes.secondayCont}>
        <h2 className={classes.mainCont}>{strings.bloodSugar}</h2>
        <StyledCrossIcon
          src={"/assets/img/x.png"}
          alt="User"
          onClick={() => setOpenModal(false)}
        />

      </Grid>
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={bloodSugarSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            errors,
            handleSubmit,
            setFieldValue, validateField
          }) => {
            const handleDropdownValue = (data) => {
              if (data) {
                const ids = data.level;
                setFieldValue("readingMethod", ids);
              } else {
                setFieldValue("readingMethod", '');
              }
              validateField("readingMethod");
            };
            
            return <StyledFormik>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FieldWrapper
                    name="sugarLevel"
                    label={`${strings.sugarLevel}`}
                    type="number"
                    onChange={(e) => {
                      handleChange("sugarLevel")(e);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SelectionDropdown
                    name="readingMethod"
                    label={`${strings.readingType}`}
                    list={bloodSugarLevels}
                    handleDropdownValue={handleDropdownValue}
                  />
                  {/* <BloodSugarLevelDropdown
                    name="readingMethod"
                    label={`${strings.readingType}`}
                    onChange={(e) => {
                      handleChange("readingMethod")(e);
                    }}
                    list={bloodSugarLevels}
                  /> */}
                </Grid>

                <Grid item xs={12}>
                  <FieldWrapper
                    name="note"
                    label={`${strings.note}`}
                    type="text"
                    onChange={(e) => {
                      handleChange("note")(e);
                    }}
                  />
                </Grid>
              </Grid>
              <Box m={1} pt={1}>
                <StyledButton
                  name="submit"
                  disabled={Object.keys(errors).length > 0 || buttonLoading}
                  onClick={handleSubmit}
                  variant="contained">
                  {buttonLoading ? (
                    <CircularProgress
                      style={{ color: "white" }}
                      size={20}
                      thickness={5}
                    />
                  ) : `${strings.save}`}

                </StyledButton>
              </Box>
            </StyledFormik>
          }}
        </Formik>
      </div>
    </div>
  )
}

export default BloodSugar;